import React, { useState } from 'react';
import {
  Box, Typography, Grid, Paper, Button, Chip, Stack, Divider, Collapse,
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import LocalShippingIcon from '@mui/icons-material/LocalShipping';
// import DownloadIcon from '@mui/icons-material/Download';
import LockIcon from '@mui/icons-material/Lock';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

const PATREON_URL = 'https://www.patreon.com/panekopanko';

const products: {
  title: string; type: string; price: string; emoji: string; color: string;
  badge: string | null; desc: string; tags: string[]; icon: React.ReactNode; tier: string;
}[] = [
  /* {
    title: 'Void Cat VRM Avatar',
    type: 'Digital',
    price: '€55',
    emoji: '🐈‍⬛',
    color: '#b44fff',
    badge: 'Bestseller',
    desc: 'Ready-to-use VRM avatar with 20 expressions, tail & ear physics. VTube Studio compatible.',
    tags: ['VRM', 'VTS', 'VRChat'],
    icon: <DownloadIcon />,
    tier: 'Supporter',
  },
  {
    title: 'Sakura Cyber Overlay Pack',
    type: 'Digital',
    price: '€20',
    emoji: '🌸',
    color: '#ff6eb4',
    badge: 'New',
    desc: 'Complete stream overlay bundle: alerts, panels, overlays, and screen layouts. 4K resolution.',
    tags: ['OBS', 'Streamlabs', 'PNG'],
    icon: <DownloadIcon />,
    tier: 'Follower',
  },
  {
    title: 'PinkPill SAO Badge PCB',
    type: 'Physical',
    price: '€30',
    emoji: '💊',
    color: '#ff9fd0',
    badge: 'Limited',
    desc: 'Hand-assembled SAO badge with RGB matrix display and wireless mesh. Includes USB-C cable.',
    tags: ['PCB', 'RP2040', 'SAO'],
    icon: <LocalShippingIcon />,
    tier: 'Supporter',
  },
  {
    title: 'Hacker Sticker Sheet',
    type: 'Physical',
    price: '€6',
    emoji: '🏷️',
    color: '#c97cff',
    badge: null,
    desc: '20-piece die-cut vinyl sticker sheet featuring cute hacker, circuit, and VTuber designs.',
    tags: ['Vinyl', 'Waterproof'],
    icon: <LocalShippingIcon />,
    tier: 'Follower',
  },
  {
    title: 'CTF Coaching Session',
    type: 'Service',
    price: '€75',
    emoji: '🏴',
    color: '#ff6eb4',
    badge: null,
    desc: '2-hour 1-on-1 CTF coaching session covering reverse engineering, pwn, or hardware challenges.',
    tags: ['1:1', 'Online', '2hr'],
    icon: <DownloadIcon />,
    tier: 'Hacker',
  },
  {
    title: 'Mochi Keyboard Keycap Set',
    type: 'Physical',
    price: '€42',
    emoji: '🍡',
    color: '#ff6eb4',
    badge: 'Pre-order',
    desc: 'Cherry-profile PBT keycap set in soft pink & lavender colorway. Compatible with MX switches.',
    tags: ['PBT', 'Cherry', 'MX'],
    icon: <LocalShippingIcon />,
    tier: 'Supporter',
  }, */
];

const featuredPosts: {
  id: number; tier: string; tierColor: string; date: string; emoji: string;
  title: string; preview: string; fullContent: string[]; likes: number; comments: number; locked: boolean;
}[] = [
  /* {
    id: 1,
    tier: 'Hacker',
    tierColor: '#ff6eb4',
    date: 'March 2025',
    emoji: '🔐',
    title: 'Breaking MIFARE Classic on a Budget: My Flipper Zero Toolkit Deep-Dive',
    preview: 'I spent three weekends reverse-engineering the nested authentication attack for MIFARE Classic cards and building a clean Flipper Zero module around it. Here\'s everything I learned — including the timing calibration nightmare.',
    fullContent: [
      'MIFARE Classic is everywhere. Hotel key cards, gym fobs, office badges — most of them running 15-year-old crypto that was broken in 2008. And yet here we are. The Flipper Zero can read and write these cards out of the box, but its built-in nested attack support is limited.',
      'So I wrote a custom module. The core challenge: the nested attack requires recovering two 32-bit keystream values from two nonces collected in a single authentication session. On a microcontroller with 256KB RAM you can\'t load a full dictionary — you need to stream it from SD card and filter on the fly.',
      'The really fun part was timing calibration. The ST25R3916 RF frontend needs sub-microsecond precision for the attack to work. I ended up with an oscilloscope on the NFC clock signal, measuring actual frame timings against the theoretical values and adjusting the firmware constants until the attack succeeded consistently across 12 different card variants.',
      'Full source is on GitHub. The writeup covers: protocol internals, the firmware architecture, how I structured the streaming dictionary, and the oscilloscope methodology. Patreon supporters get the annotated source with all my inline notes intact.',
    ],
    likes: 142,
    comments: 38,
    locked: false,
  },
  {
    id: 2,
    tier: 'Supporter',
    tierColor: '#b44fff',
    date: 'February 2025',
    emoji: '⌨️',
    title: 'CherryBoard v2: From KiCad Schematic to First Keystroke',
    preview: 'Full build log of my open-source 65% ortholinear keyboard — from initial schematic capture all the way through JLCPCB assembly, QMK bringup, and debugging the one USB-C ESD fault I definitely should have caught in review.',
    fullContent: [
      'CherryBoard v2 has been six months in the making. The v1 was a quick ATmega32U4 job; v2 is a ground-up redesign around RP2040 with per-key SK6812 MINI-E RGB, Kailh hotswap sockets, and a proper USB-C ESD protection circuit. Emphasis on "proper" — because my first attempt at the ESD layout definitely wasn\'t.',
      'The PRTR5V0U2X TVS diodes ended up too far from the connector. When I tested ESD immunity by dragging a charged bag across the desk near the board (very scientific), the MCU brownout reset. Lesson learned: keep your TVS within 2mm of the connector pins, full stop.',
      'I\'ll walk through the complete KiCad design, the component selection rationale (why SK6812 over WS2812B, why RP2040 over ATmega), and the QMK bringup process including the one GPIO I wired backwards. Gerbers, BOM with LCSC part numbers, and the QMK config are all in the repo. Supporter tier gets the KiCad project file with my full component library.',
    ],
    likes: 89,
    comments: 24,
    locked: false,
  },
  {
    id: 3,
    tier: 'Hacker',
    tierColor: '#ff6eb4',
    date: 'February 2025',
    emoji: '🐉',
    title: 'Mecha Dragon VRChat World Avatar: Full Technical Breakdown',
    preview: 'How I got a 185k-triangle dragon with dynamic wing physics down to a Quest-compatible 70k-triangle version without losing the silhouette — and the custom URP shader that makes the armour glow on command.',
    fullContent: [
      'The wing constraint rig is the part I\'m most proud of on this project. Spring bones alone on a large wing membrane cause the geometry to clip into the body during fast head turns. The solution: overlay a lightweight IK chain that acts as a collision floor, driven by the same animation but constrained to stay above the body surface. The spring bones then drive the secondary motion on top of that.',
      'For the Quest LOD, the key insight is that your silhouette matters far more than surface detail. I kept full resolution on the face, hands, and wing leading edges — the parts a viewer\'s eye naturally tracks — and aggressively decimated the back armour plating which is rarely visible. Going from 185k to 70k without the standard "melted cheese" look took three passes with manual cleanup in Blender.',
      'The damage glow shader is a URP custom lit shader that lerps between two texture sets (clean / cracked) based on a float avatar parameter. The tricky part is blending the normal maps correctly at the seam — a naive lerp gives you a harsh line. The fix is a triplanar blend with feathering in the transition zone. Full shader source in the Hacker tier download.',
    ],
    likes: 203,
    comments: 51,
    locked: true,
  },
  {
    id: 4,
    tier: 'Follower',
    tierColor: '#c97cff',
    date: 'January 2025',
    emoji: '⛩️',
    title: 'How I Built the Neon Shrine Stream Kit: Process & Mistakes',
    preview: 'Behind the scenes on my most-downloaded overlay pack. What worked, what didn\'t, and why I almost shipped a version with a broken WebM alpha channel that would have looked like garbage on AMD GPUs.',
    fullContent: [
      'The Neon Shrine kit started as a personal stream refresh and turned into my best-selling product. The concept — traditional Japanese shrine aesthetics crossed with neon cyberpunk — sounds like it should be a mess, but the key is treating the traditional elements as shapes and silhouettes rather than detailed motifs, then running the neon palette over the top.',
      'The AMD WebM alpha bug nearly shipped. OBS\'s browser source uses Chromium under the hood, and the VP8/VP9 alpha decoding behaves differently on AMD vs Nvidia when the bitrate gets close to the encode limit. My test machine is Nvidia, so all my QA passed. The fix was dropping to a lower bitrate with a 2-pass encode — the quality difference is invisible, but the decode path becomes consistent across GPU vendors.',
      'The After Effects master colour control system took a full day to build properly. Each composition has a single colour control effect at the top of the layer stack, and every colour-sensitive property in every nested comp is expression-linked back to it via a project-level script. Change one slider, the whole 47-file kit updates. Worth every minute.',
    ],
    likes: 67,
    comments: 19,
    locked: false,
  }, */
];

const badgeColors: Record<string, string> = {
  Bestseller: '#ff6eb4',
  New: '#b44fff',
  Limited: '#ff9fd0',
  'Pre-order': '#c97cff',
};

const tierOrder = ['Follower', 'Supporter', 'Hacker'];
const tierPrices: Record<string, string> = {
  Follower: '€5 / mo',
  Supporter: '€12 / mo',
  Hacker: '€25 / mo',
};
const tierColors: Record<string, string> = {
  Follower: '#c97cff',
  Supporter: '#b44fff',
  Hacker: '#ff6eb4',
};

export default function Shop() {
  const [expandedPost, setExpandedPost] = useState<number | null>(null);

  return (
    <Box
      id="shop"
      sx={{
        py: { xs: 10, md: 16 },
        px: { xs: 3, md: 8 },
        background: 'linear-gradient(180deg, transparent, rgba(255,110,180,0.03), transparent)',
      }}
    >
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        {/* Header */}
        <Typography variant="overline" sx={{ color: 'primary.main', letterSpacing: 6, fontSize: '0.75rem' }}>
          04 — SHOP & PATREON
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 2, mt: 1, mb: 2 }}>
          <Typography variant="h2" sx={{ fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
            Support & Store
          </Typography>
          <Button
            variant="contained"
            href={PATREON_URL}
            target="_blank"
            rel="noopener noreferrer"
            endIcon={<OpenInNewIcon />}
            sx={{
              background: 'linear-gradient(135deg, #ff424d, #e6461a)',
              fontWeight: 700,
              px: 3, py: 1.2,
              '&:hover': { boxShadow: '0 0 24px rgba(255,66,77,0.45)' },
            }}
          >
            Join on Patreon
          </Button>
        </Box>
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 10, maxWidth: 580 }}>
          Everything is sold and delivered through Patreon — join to access digital downloads,
          exclusive posts, early access, and physical rewards shipped every month.
        </Typography>

        {/* Patreon tiers */}
        <Typography variant="overline" sx={{ color: 'primary.main', letterSpacing: 5, fontSize: '0.75rem' }}>
          MEMBERSHIP TIERS
        </Typography>
        <Typography variant="h4" sx={{ mt: 1, mb: 4, fontSize: { xs: '1.6rem', md: '2rem' } }}>
          Choose Your Tier
        </Typography>
        <Grid container spacing={3} sx={{ mb: 12 }}>
          {tierOrder.map((tier, i) => (
            <Grid size={{ xs: 12, md: 4 }} key={tier}>
              <Paper
                sx={{
                  p: 4, height: '100%',
                  background: i === 1 ? `linear-gradient(135deg, ${tierColors[tier]}18, ${tierColors[tier]}08)` : 'rgba(22,15,32,0.9)',
                  border: i === 1 ? `2px solid ${tierColors[tier]}77` : `1px solid ${tierColors[tier]}25`,
                  position: 'relative',
                  transition: 'all 0.3s',
                  '&:hover': { transform: 'translateY(-4px)', boxShadow: `0 12px 40px ${tierColors[tier]}20` },
                }}
              >
                {i === 1 && (
                  <Chip label="Most Popular" size="small" sx={{
                    position: 'absolute', top: -14, left: '50%', transform: 'translateX(-50%)',
                    background: `linear-gradient(135deg, ${tierColors[tier]}, ${tierColors[tier]}bb)`,
                    color: '#fff', fontWeight: 700,
                  }} />
                )}
                <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1 }}>
                  <Typography sx={{ fontSize: '1.8rem' }}>
                    {tier === 'Follower' ? '🌸' : tier === 'Supporter' ? '💜' : '🔐'}
                  </Typography>
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1 }}>{tier}</Typography>
                    <Typography variant="h5" sx={{ color: tierColors[tier], fontWeight: 800 }}>
                      {tierPrices[tier]}
                    </Typography>
                  </Box>
                </Stack>
                <Divider sx={{ borderColor: `${tierColors[tier]}20`, my: 2 }} />
                <Stack spacing={1.2} sx={{ mb: 3 }}>
                  {(tier === 'Follower' ? [
                    'Exclusive Patreon posts',
                    'Early stream announcements',
                    'Discord community access',
                    'Monthly wallpaper pack',
                  ] : tier === 'Supporter' ? [
                    'Everything in Follower',
                    'Monthly digital download',
                    'WIP previews & behind-the-scenes',
                    'Vote on future projects',
                    'Name in stream credits',
                  ] : [
                    'Everything in Supporter',
                    'Full project source files',
                    'Hardware hacking posts (unpaywalled)',
                    'Monthly 1:1 Q&A session',
                    'Private Discord channel',
                    'Physical reward (quarterly)',
                  ]).map((f) => (
                    <Stack key={f} direction="row" spacing={1} alignItems="flex-start">
                      <Typography sx={{ color: tierColors[tier], mt: '2px', flexShrink: 0 }}>✦</Typography>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>{f}</Typography>
                    </Stack>
                  ))}
                </Stack>
                <Button
                  fullWidth
                  variant={i === 1 ? 'contained' : 'outlined'}
                  href={PATREON_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  endIcon={<OpenInNewIcon sx={{ fontSize: '14px !important' }} />}
                  sx={i === 1 ? {
                    background: `linear-gradient(135deg, ${tierColors[tier]}, ${tierColors[tier]}cc)`,
                    '&:hover': { boxShadow: `0 0 20px ${tierColors[tier]}44` },
                  } : {
                    borderColor: `${tierColors[tier]}44`, color: tierColors[tier],
                    '&:hover': { borderColor: tierColors[tier], background: `${tierColors[tier]}10` },
                  }}
                >
                  Join as {tier}
                </Button>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Featured posts */}
        <Typography variant="overline" sx={{ color: 'primary.main', letterSpacing: 5, fontSize: '0.75rem' }}>
          FEATURED POSTS
        </Typography>
        <Typography variant="h4" sx={{ mt: 1, mb: 2, fontSize: { xs: '1.6rem', md: '2rem' } }}>
          From the Feed
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 6, maxWidth: 520 }}>
          A preview of what's inside. Some posts are open — others require the matching tier to read in full.
        </Typography>

        <Stack spacing={3} sx={{ mb: 12 }}>
          {featuredPosts.map((post) => {
            const isExpanded = expandedPost === post.id;
            return (
              <Paper
                key={post.id}
                sx={{
                  background: 'rgba(22,15,32,0.9)',
                  border: `1px solid ${isExpanded ? post.tierColor + '55' : post.tierColor + '18'}`,
                  overflow: 'hidden',
                  transition: 'border-color 0.3s',
                }}
              >
                {/* Post header */}
                <Box sx={{ p: { xs: 3, md: 4 } }}>
                  <Stack direction="row" spacing={2} alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" sx={{ gap: 2 }}>
                    <Stack direction="row" spacing={2} alignItems="flex-start" sx={{ flex: 1, minWidth: 0 }}>
                      <Typography sx={{
                        fontSize: '2.2rem', flexShrink: 0,
                        filter: `drop-shadow(0 0 12px ${post.tierColor}77)`,
                      }}>
                        {post.emoji}
                      </Typography>
                      <Box sx={{ minWidth: 0 }}>
                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1, flexWrap: 'wrap', gap: 1 }}>
                          <Chip
                            label={post.tier}
                            size="small"
                            sx={{
                              background: `${post.tierColor}18`,
                              border: `1px solid ${post.tierColor}44`,
                              color: post.tierColor,
                              fontWeight: 700,
                              fontSize: '0.68rem',
                            }}
                          />
                          <Typography variant="caption" sx={{ color: 'text.secondary' }}>{post.date}</Typography>
                          {post.locked && (
                            <Chip
                              icon={<LockIcon sx={{ fontSize: '12px !important' }} />}
                              label="Members only"
                              size="small"
                              sx={{
                                background: 'rgba(255,110,180,0.08)',
                                border: '1px solid rgba(255,110,180,0.2)',
                                color: 'text.secondary',
                                fontSize: '0.65rem',
                              }}
                            />
                          )}
                        </Stack>
                        <Typography variant="h6" sx={{ fontWeight: 700, fontSize: { xs: '1rem', md: '1.15rem' }, lineHeight: 1.3 }}>
                          {post.title}
                        </Typography>
                      </Box>
                    </Stack>
                  </Stack>

                  <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.8, mt: 2 }}>
                    {post.preview}
                  </Typography>

                  {/* Expanded content */}
                  <Collapse in={isExpanded && !post.locked}>
                    <Divider sx={{ borderColor: `${post.tierColor}20`, my: 3 }} />
                    <Stack spacing={2.5}>
                      {post.fullContent.map((para, j) => (
                        <Typography key={j} variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.9 }}>
                          {para}
                        </Typography>
                      ))}
                    </Stack>
                  </Collapse>

                  {/* Locked blurred preview */}
                  <Collapse in={isExpanded && post.locked}>
                    <Divider sx={{ borderColor: `${post.tierColor}20`, my: 3 }} />
                    <Box sx={{ position: 'relative' }}>
                      <Typography variant="body2" sx={{
                        color: 'text.secondary', lineHeight: 1.9,
                        filter: 'blur(5px)', userSelect: 'none',
                        pointerEvents: 'none',
                      }}>
                        {post.fullContent[0]}
                      </Typography>
                      <Box sx={{
                        position: 'absolute', inset: 0,
                        background: `linear-gradient(180deg, transparent 0%, rgba(22,15,32,0.95) 70%)`,
                        display: 'flex', alignItems: 'flex-end', pb: 1,
                      }}>
                        <Button
                          href={PATREON_URL}
                          target="_blank"
                          rel="noopener noreferrer"
                          variant="contained"
                          startIcon={<LockIcon />}
                          endIcon={<OpenInNewIcon sx={{ fontSize: '14px !important' }} />}
                          sx={{
                            mx: 'auto',
                            background: `linear-gradient(135deg, ${post.tierColor}, ${post.tierColor}cc)`,
                            '&:hover': { boxShadow: `0 0 20px ${post.tierColor}44` },
                          }}
                        >
                          Unlock with {post.tier} tier on Patreon
                        </Button>
                      </Box>
                    </Box>
                  </Collapse>

                  {/* Footer actions */}
                  <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: 3 }}>
                    <Stack direction="row" spacing={0.8} alignItems="center">
                      <FavoriteIcon sx={{ fontSize: 15, color: '#ff6eb4' }} />
                      <Typography variant="caption" sx={{ color: 'text.secondary' }}>{post.likes}</Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.8} alignItems="center">
                      <ChatBubbleOutlineIcon sx={{ fontSize: 15, color: 'text.secondary' }} />
                      <Typography variant="caption" sx={{ color: 'text.secondary' }}>{post.comments}</Typography>
                    </Stack>
                    <Box sx={{ flex: 1 }} />
                    {!post.locked ? (
                      <Button
                        size="small"
                        onClick={() => setExpandedPost(isExpanded ? null : post.id)}
                        endIcon={isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        sx={{
                          color: post.tierColor,
                          fontSize: '0.78rem',
                          '&:hover': { background: `${post.tierColor}12` },
                        }}
                      >
                        {isExpanded ? 'Collapse' : 'Read more'}
                      </Button>
                    ) : (
                      <Button
                        size="small"
                        onClick={() => setExpandedPost(isExpanded ? null : post.id)}
                        endIcon={isExpanded ? <ExpandLessIcon /> : <LockIcon sx={{ fontSize: '14px !important' }} />}
                        sx={{
                          color: post.tierColor,
                          fontSize: '0.78rem',
                          '&:hover': { background: `${post.tierColor}12` },
                        }}
                      >
                        {isExpanded ? 'Collapse' : 'Members only'}
                      </Button>
                    )}
                  </Stack>
                </Box>
              </Paper>
            );
          })}
        </Stack>

        <Box sx={{ textAlign: 'center', mb: 12 }}>
          <Button
            variant="outlined"
            href={PATREON_URL}
            target="_blank"
            rel="noopener noreferrer"
            endIcon={<OpenInNewIcon />}
            sx={{
              borderColor: 'rgba(255,110,180,0.3)', color: 'text.secondary',
              '&:hover': { borderColor: 'primary.main', color: 'primary.main' },
            }}
          >
            See all posts on Patreon
          </Button>
        </Box>

        {/* Product grid */}
        <Typography variant="overline" sx={{ color: 'primary.main', letterSpacing: 5, fontSize: '0.75rem' }}>
          REWARDS & MERCH
        </Typography>
        <Typography variant="h4" sx={{ mt: 1, mb: 2, fontSize: { xs: '1.6rem', md: '2rem' } }}>
          What You Get
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 6, maxWidth: 520 }}>
          Rewards are delivered via Patreon at the tier shown. Physical items ship quarterly.
        </Typography>

        <Grid container spacing={3}>
          {products.map((product) => (
            <Grid size={{ xs: 12, sm: 6, lg: 4 }} key={product.title}>
              <Paper
                sx={{
                  overflow: 'hidden',
                  background: 'rgba(22,15,32,0.9)',
                  border: '1px solid rgba(255,110,180,0.12)',
                  transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
                  '&:hover': {
                    borderColor: product.color,
                    transform: 'translateY(-6px)',
                    boxShadow: `0 12px 40px ${product.color}22`,
                  },
                }}
              >
                <Box sx={{
                  height: 150,
                  background: `linear-gradient(135deg, ${product.color}18, ${product.color}08)`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  position: 'relative',
                }}>
                  <Box sx={{
                    position: 'absolute', inset: 0,
                    backgroundImage: `radial-gradient(${product.color}15 1px, transparent 1px)`,
                    backgroundSize: '18px 18px',
                  }} />
                  <Typography sx={{ fontSize: '3rem', position: 'relative', zIndex: 1, filter: `drop-shadow(0 0 16px ${product.color}88)` }}>
                    {product.emoji}
                  </Typography>
                  {product.badge && (
                    <Chip label={product.badge} size="small" sx={{
                      position: 'absolute', top: 10, left: 10,
                      background: badgeColors[product.badge] ?? product.color,
                      color: '#fff', fontWeight: 700, fontSize: '0.68rem',
                    }} />
                  )}
                  <Chip
                    label={`${product.tier} tier`}
                    size="small"
                    sx={{
                      position: 'absolute', top: 10, right: 10,
                      background: 'rgba(13,10,18,0.75)',
                      border: `1px solid ${tierColors[product.tier]}55`,
                      color: tierColors[product.tier],
                      fontSize: '0.65rem',
                    }}
                  />
                </Box>

                <Box sx={{ p: 3 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '0.95rem' }}>{product.title}</Typography>
                    <Typography variant="h6" sx={{ color: product.color, fontWeight: 700, fontSize: '1rem', ml: 1, whiteSpace: 'nowrap' }}>
                      {product.price}
                    </Typography>
                  </Box>
                  <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.7, mb: 2 }}>
                    {product.desc}
                  </Typography>
                  <Stack direction="row" spacing={0.8} flexWrap="wrap" sx={{ gap: 0.8, mb: 3 }}>
                    {product.tags.map((tag) => (
                      <Chip key={tag} label={tag} size="small" sx={{
                        fontSize: '0.65rem',
                        background: `${product.color}12`,
                        border: `1px solid ${product.color}33`,
                        color: product.color,
                      }} />
                    ))}
                  </Stack>
                  <Button
                    fullWidth
                    variant="outlined"
                    href={PATREON_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    startIcon={product.icon}
                    endIcon={<OpenInNewIcon sx={{ fontSize: '13px !important' }} />}
                    sx={{
                      borderColor: `${product.color}55`, color: product.color,
                      '&:hover': { borderColor: product.color, background: `${product.color}10`, boxShadow: `0 0 16px ${product.color}22` },
                    }}
                  >
                    Get on Patreon
                  </Button>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Footer strip */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={3}
          justifyContent="center"
          alignItems="center"
          sx={{ mt: 10, pt: 6, borderTop: '1px solid rgba(255,110,180,0.1)' }}
        >
          {[
            { emoji: '🔒', text: 'Secure via Patreon' },
            { emoji: '📦', text: 'Worldwide Shipping' },
            { emoji: '⚡', text: 'Instant Digital Delivery' },
            { emoji: '💬', text: 'Discord Community' },
          ].map((item) => (
            <Stack key={item.text} direction="row" spacing={1.5} alignItems="center">
              <Typography sx={{ fontSize: '1.3rem' }}>{item.emoji}</Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>{item.text}</Typography>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Box>
  );
}
